export default {
  computed: {
    metaItems() {
      return [];
    },
  },
};
